// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';

import { useQueryIntegrationPlaybooks, isPlaybookDisabled } from '@ion/api';
import { MrInputSelect, formValidators } from '@ion/components';

const { validateRequired } = formValidators;

export const RevisionSelect = ({ formState, validateField, onChange, integrationId }) => {
  const { data: integrationPlaybooksData, loading } = useQueryIntegrationPlaybooks({
    variables: { integrationId: integrationId },
  });

  if (loading) {
    return null;
  }

  const revisionsSelectOptions = integrationPlaybooksData
    ? integrationPlaybooksData.playbooks.map(playbook => {
        const isDisabled = isPlaybookDisabled(playbook);
        return {
          text: isDisabled ? `Revision ${playbook.revision} (disabled)` : `Revision ${playbook.revision}`,
          value: playbook.id,
          disabled: isDisabled,
        };
      })
    : [];

  return (
    <MrInputSelect
      options={revisionsSelectOptions}
      onBlur={validateField}
      validators={[validateRequired()]}
      name="revision"
      label="Select Revision"
      placeholder={integrationId ? 'Select...' : 'Please select an integration first...'}
      value={formState.revision.value}
      onChange={onChange}
      errorMsg={formState.revision.errorMsg}
      disabled={!integrationPlaybooksData}
      menuPosition="fixed"
      maxMenuHeight={260}
      alphabetized={false}
      testId="revisionSelect"
    />
  );
};
RevisionSelect.propTypes = {
  integrationId: PropTypes.string,
  formState: PropTypes.object.isRequired,
  validateField: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
